const brokerUrl = () => import.meta.env.VITE_BROKER_URL;

const post = async (path, body) => {
  const res = await fetch(`${brokerUrl()}${path}`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });
  const json = await res.json().catch(() => ({}));
  if (! res.ok) {
    throw new Error(`Broker ${path} a échoué: ${json.error ?? res.status}`);
  }
  return json;
};

export const exchangeCode = (code, verifier) => post("/oauth/exchange", {
  code,
  code_verifier: verifier,
});

export const refreshToken = (refresh_token) => post("/oauth/refresh", { refresh_token });